import { ChartContent } from './ChartContent'
import { useGetChart } from './useGetChart'
import { useTileFilterSelections } from '../../../hooks/useTileFilterSelections'

export const ChartComponent = ({ id }: { id: string }) => {
  const { data } = useGetChart(id, [])
  const { tileFilterSelections, filterChangeHandler } = useTileFilterSelections(data.filters)

  // Refetch with filters applied
  const dataWithFilters = useGetChart(id, tileFilterSelections).data

  return (
    <ChartContent
      data={dataWithFilters}
      tileFilterSchema={dataWithFilters.filters}
      filterChangeHandler={filterChangeHandler}
    />
  )
}
